import type { GetAudienceName } from './types'

export const getAudienceName = ({ audience, language, t }: GetAudienceName) => {
  const { nameDe, nameEn, nameFr, nameIt } = audience

  if (audience.audienceType === 'owner') return t('page.cms.content.target.owner')

  const prefix = audience.audienceType === 'team' ? t('page.cms.content.target.team') : ''

  switch (language) {
    case 'en':
    case 'en-GB':
      return ` ${prefix} ${nameEn}`
    case 'de':
      return ` ${prefix} ${nameDe}`
    case 'fr':
      return ` ${prefix} ${nameFr}`
    case 'it':
      return ` ${prefix} ${nameIt}`
    default:
      return null
  }
}
